export const calculateYearQuarter = (date: Date): [number, number] => {
	const quarterDate = new Date(date);
	quarterDate.setMonth(quarterDate.getMonth() - 3);
	return [quarterDate.getFullYear(), Math.floor(quarterDate.getMonth() / 3) + 1];
};
